export const driverJobKeys = {
    all: ['driver-jobs'] as const,
    detail: (jobId: string, accessToken: string) =>
        [...driverJobKeys.all, jobId, accessToken] as const,
}
